export enum SharingMethod {
  'EMAIL' = 'EMAIL',
  'FAX' = 'FAX',
  'NOTIFICATION' = 'NOTIFICATION',
}
